import React from 'react';
import AdditionalInformation from './AdditionalInformation';

function Item(props) {
	/*
        Props
            - itemId
            - checked
            - content
            - infoUrl
            - handleChange
    */

	let { content, type } = props;

	return (
		<li>
			<div>
				<label className={type === 'category' ? 'item-category': ''}>{content}</label>
                <AdditionalInformation url={props.infoUrl} />
			</div>
		</li>
	);
}

export default Item;



// WEBPACK FOOTER //
// ./src/components/Item.js